import { createContext, useContext } from 'react'

export type LiveAnnouncerContextValue = {
  announce: (
    message: string,
    /* Defaults to false, meaning announcements don't interrupt the SR flow */
    assertive?: boolean
  ) => void
}

export const LiveAnnouncerContext =
  createContext<LiveAnnouncerContextValue | null>(null)

export const useLiveAnnouncer = () => {
  const context = useContext(LiveAnnouncerContext)

  if (!context) {
    throw new Error(
      'useLiveAnnouncer must be used within <LiveAnnouncerProvider>'
    )
  }

  return context
}
